export class Folder {
	public caseId: string;
	public folderId: string;
	public parentFolderId: string;
	public folderName: string;
	public left: number;
	public right: number;
	public isDefaultType: boolean;
	public isCaseRootNode: boolean;
}
